import { render, staticRenderFns } from "./SchoolsPath.vue?vue&type=template&id=2cfd54e2&"
import script from "./SchoolsPath.vue?vue&type=script&lang=js&"
export * from "./SchoolsPath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports